module.exports = __webpack_public_path__ + "static/img/ksjlbg.d4fce51b.png";